export default __webpack_public_path__ + "static/media/113.1feff7f2.jpeg";